import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export type GateButtonAction = 'open' | 'close';

/**
 * Square icon button for a manual gate command (CWS-1714). `open` shows the
 * barrier arm raised, `close` the arm lowered; the label is the tooltip and the
 * accessible name.
 */
@Component({
  selector: 'app-gate-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gate-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './gate-button.component.scss',
})
export class GateButtonComponent {
  @Input() action: GateButtonAction = 'open';
  @Input() disabled = false;
  /** A command for this button is in flight: show a spinner and ignore clicks. */
  @Input() busy = false;
  @Output() pressed = new EventEmitter<void>();

  get label(): string {
    return this.action === 'close' ? 'Close gate' : 'Open gate';
  }

  onClick(event: Event): void {
    event.stopPropagation();
    if (!this.disabled && !this.busy) {
      this.pressed.emit();
    }
  }
}
